
// import React, { useEffect, useState } from "react";
// import classes from "./MatchLayout.module.css";
// import date from "../helpers/date";
// import { useNavigate } from "react-router-dom";
// import { useSelector } from "react-redux";
// import axios from "axios";
// import { baseUrl, getUserTeam, getUserTeamApi, getUserTeamsApi } from "../api/api";
 
// const MatchLayout = ({ match, hideButton }) => {
//   const { lang } = useSelector((state) => state.langSlice);
//   const { user } = useSelector((state) => state?.userSlice);
//   const navigate = useNavigate();
//   const [contestId, setContestId] = useState(null);
//  const user_id=1234;
 
//   const [teamExists, setTeamExists] = useState(false);
 
//   const handleNavigate = (path) => {
//     navigate(`/match/${path?.id}/${path?.homeTeamId}/${path?.awayTeamId}`);
//   };
 
//   const handleNavigateToContests = (path) => {
//     navigate(`/match/contests/${path?.id}/${path?.homeTeamId}/${path?.awayTeamId}`);
//   };
 
//   const handleNavigateToEditTeam = (path) => {
//     // navigate(`/match/created-team/${path?.id}/${path?.homeTeamId}/${path?.awayTeamId}/null`);
//     navigate(`/match/created-team/${path?.id}/${path?.homeTeamId}/${path?.awayTeamId}/${contestId}`);
 
//   };
 
// useEffect(() => {
//   const checkTeamExistence = async () => {
//     try {
//       const res = await axios.post(`${baseUrl}${getUserTeamsApi}`, {
//         // user_id: user?.id,
//         user_id:user_id,
//         match_fixture_id: match?.fixture_id,
//       },
//     //      {
//     //       headers: {
//     //         Authorization: `Bearer ${user?.token}`,
//     //       },
//     // }  
    
//     );
 
//       // console.log("Team check API response:", res);
 
//       const team = res?.data?.result?.[0];
 
//       if (team) {
//         console.log("Team already exists");
//         setTeamExists(true);
//         if (team?.contest_id) {
//           setContestId(team.contest_id);
//         }
//       } else {
//         console.log("🆕 No existing team found");
//         setTeamExists(false);
//         setContestId(null);
//       }
//     } catch (error) {
//       console.error("Error checking team existence:", error);
//     }
//   };
 
//   // if (user?.id && match?.fixture_id) {
//     if (user_id && match?.fixture_id) {
//     checkTeamExistence();
//   }
// // }, [user?.id, match?.fixture_id]);
//  }, [user_id, match?.fixture_id])
//   return (
//     <div className={`${classes.match_flex_col} ${hideButton && classes.height_adjustment}`}>
//       {/* Match Status */}
//       {match?.matchStatus === "Match Finished" && (
//         <div className={classes.match_status}>
//           <p className={classes.status_text}>FT</p>
//         </div>
//       )}
 
//       {match?.matchTime != null && match?.matchStatus !== "Match Finished" && (
//         <div className={classes.match_status}>
//           <p className={classes.status_text}>
//             <i
//               className={`fa fa-circle ${classes.text_danger_glow} ${classes.blink}`}
//               style={{ fontSize: "10px" }}
//             ></i>
//             <span style={{ marginLeft: "10px" }}>
//               {match?.matchStatus === "Halftime"
//                 ? lang === "english"
//                   ? "Half-Time"
//                   : lang === "spanish"
//                   ? "Medio tiempo"
//                   : lang === "french"
//                   ? "Mi-temps"
//                   : lang === "arabic"
//                   ? "نصف الوقت"
//                   : "Half-Time"
//                 : `${match?.matchTime}'`}
//             </span>
//           </p>
//         </div>
//       )}
 
//       {/* Match Info */}
//       <div className={classes.match_container}>
//         <div className={classes.match_sub_container}>
//           {/* Home */}
//           <div className={classes.home_team_section}>
//             <div className={classes.home_team_logo_name}>
//               <div className={classes.home_logo_container}>
//                 <img src={match?.homeLogo} alt={match?.homeTeam} className={classes.home_logo} />
//               </div>
//               <div className={classes.home_team_name}>
//                 <p className={classes.name}>{match?.homeTeam}</p>
//               </div>
//             </div>
//             <div className={classes.home_team_goals}>
//               <p className={classes.name}>{match?.homeGoals}</p>
//             </div>
//           </div>
 
//           {/* Away */}
//           <div className={classes.away_team_section}>
//             <div className={classes.away_team_logo_name}>
//               <div className={classes.away_logo_container}>
//                 <img src={match?.awayLogo} alt={match?.awayTeam} className={classes.away_logo} />
//               </div>
//               <div className={classes.away_team_name}>
//                 <p className={classes.name}>{match?.awayTeam}</p>
//               </div>
//             </div>
//             <div className={classes.away_team_goals}>
//               <p className={classes.name}>{match?.awayGoals}</p>
//             </div>
//           </div>
//         </div>
 
//         <div className={classes.match_date_container}>
//           <div className={classes.line}></div>
//           <div className={classes.match_date_time}>
//             <p className={classes.date}>{date(match?.time)?.date}</p>
//             <p className={classes.time}>{date(match?.time)?.time}</p>
//           </div>
//         </div>
//       </div>
 
//       {/* Buttons */}
//       {!hideButton && (
//         <div className={classes.match_btns}>
//           <button
//             className={classes.monitor_btn}
//             onClick={() =>
//               handleNavigate({
//                 id: match?.fixture_id,
//                 homeTeamId: match?.homeTeamId,
//                 awayTeamId: match?.awayTeamId,
//               })
//             }
//           >
//             {lang === "english"
//               ? "View Match"
//               : lang === "spanish"
//               ? "Ver partido"
//               : lang === "french"
//               ? "Voir la correspondance"
//               : lang === "arabic"
//               ? "عرض المباراة"
//               : "View Match"}
//           </button>
 
//           {match?.matchStatus !== "Match Finished" && match?.matchTime == null && (
//             <button
//               className={classes.monitor_btn}
//               onClick={() =>
//                 teamExists
//                   ? handleNavigateToEditTeam({
//                       id: match?.fixture_id,
//                       homeTeamId: match?.homeTeamId,
//                       awayTeamId: match?.awayTeamId,
//                     })
//                   :
//                   handleNavigateToContests({
//                       id: match?.fixture_id,
//                       homeTeamId: match?.homeTeamId,
//                       awayTeamId: match?.awayTeamId,
//                     })
//               }
//             >
//               {teamExists
//                 ? lang === "english"
//                   ? "Edit Fantasy Team"
//                   : lang === "spanish"
//                   ? "Editar equipo de fantasía"
//                   : lang === "french"
//                   ? "Modifier l'équipe fantastique"
//                   : lang === "arabic"
//                   ? "تعديل فريق الخيال"
//                   : "Edit Fantasy Team"
//                 : lang === "english"
//                 ? "Create Fantasy Team"
//                 : lang === "spanish"
//                 ? "Crear equipo de fantasía"
//                 : lang === "french"
//                 ? "Créer une équipe fantastique"
//                 : lang === "arabic"
//                 ? "إنشاء فريق الخيال"
//                 : "Create Fantasy Team"}
//             </button>
//           )}
//         </div>
//       )}
//     </div>
//   );
// };
 
// export default MatchLayout;
 

import React, { useEffect, useState } from "react";
import classes from "./MatchLayout.module.css";
import date from "../helpers/date";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import axios from "axios";
import { baseUrl, getUserTeam, getUserTeamApi, getUserTeamsApi } from "../api/api";
 
const MatchLayout = ({ match, hideButton }) => {
  const { lang } = useSelector((state) => state.langSlice);
  const { user } = useSelector((state) => state?.userSlice);
  const navigate = useNavigate();
  const [contestId, setContestId] = useState(null);
  const matchDate = date(
    match?.match_date_time ?? match?.time ?? match?.date
  );
 
 
  const [teamExists, setTeamExists] = useState(false);
 
  const handleNavigate = (path) => {
    navigate(`/match/${path?.id}/${path?.homeTeamId}/${path?.awayTeamId}`);
  };
 
  const handleNavigateToContests = (path) => {
    navigate(`/match/contests/${path?.id}/${path?.homeTeamId}/${path?.awayTeamId}`);
  };
 
  const handleNavigateToEditTeam = (path) => {
    // navigate(`/match/created-team/${path?.id}/${path?.homeTeamId}/${path?.awayTeamId}/null`);
    navigate(`/match/created-team/${path?.id}/${path?.homeTeamId}/${path?.awayTeamId}/${contestId}`);
 
  };
 
useEffect(() => {
  const checkTeamExistence = async () => {
    try {
      const res = await axios.post(`${baseUrl}${getUserTeamsApi}`, {
        user_id: user?.id,
        match_fixture_id: match?.fixture_id,
      },
         {
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
    }  
   
    );
 
      // console.log("Team check API response:", res);
 
      const team = res?.data?.result?.[0];
 
      if (team) {
        console.log("Team already exists");
        setTeamExists(true);
        if (team?.contest_id) {
          setContestId(team.contest_id);
        }
      } else {
        console.log("🆕 No existing team found");
        setTeamExists(false);
        setContestId(null);
      }
    } catch (error) {
      console.error("Error checking team existence:", error);
    }
  };
 
  if (user?.id && match?.fixture_id) {
    checkTeamExistence();
  }
}, [user?.id, match?.fixture_id]);
 
  return (
    <div className={`${classes.match_flex_col} ${hideButton && classes.height_adjustment}`}>
      {/* Match Status */}
      {match?.matchStatus === "Match Finished" && (
        <div className={classes.match_status}>
          <p className={classes.status_text}>FT</p>
        </div>
      )}
 
      {match?.matchTime != null && match?.matchStatus !== "Match Finished" && (
        <div className={classes.match_status}>
          <p className={classes.status_text}>
            <i
              className={`fa fa-circle ${classes.text_danger_glow} ${classes.blink}`}
              style={{ fontSize: "10px" }}
            ></i>
            <span style={{ marginLeft: "10px" }}>
              {match?.matchStatus === "Halftime"
                ? lang === "english"
                  ? "Half-Time"
                  : lang === "spanish"
                  ? "Medio tiempo"
                  : lang === "french"
                  ? "Mi-temps"
                  : lang === "arabic"
                  ? "نصف الوقت"
                  : "Half-Time"
                : `${match?.matchTime}'`}
            </span>
          </p>
        </div>
      )}
 
      {/* Match Info */}
      <div className={classes.match_container}>
        <div className={classes.match_sub_container}>
          {/* Home */}
          <div className={classes.home_team_section}>
            <div className={classes.home_team_logo_name}>
              <div className={classes.home_logo_container}>
                <img src={match?.homeLogo} alt={match?.homeTeam} className={classes.home_logo} />
              </div>
              <div className={classes.home_team_name}>
                <p className={classes.name}>{match?.homeTeam}</p>
              </div>
            </div>
            <div className={classes.home_team_goals}>
              <p className={classes.name}>{match?.homeGoals}</p>
            </div>
          </div>
 
          {/* Away */}
          <div className={classes.away_team_section}>
            <div className={classes.away_team_logo_name}>
              <div className={classes.away_logo_container}>
                <img src={match?.awayLogo} alt={match?.awayTeam} className={classes.away_logo} />
              </div>
              <div className={classes.away_team_name}>
                <p className={classes.name}>{match?.awayTeam}</p>
              </div>
            </div>
            <div className={classes.away_team_goals}>
              <p className={classes.name}>{match?.awayGoals}</p>
            </div>
          </div>
        </div>
 
        <div className={classes.match_date_container}>
          <div className={classes.line}></div>
          <div className={classes.match_date_time}>
            <p className={classes.date}>{matchDate?.date}</p>
            <p className={classes.time}>{matchDate?.time}</p>
          </div>
        </div>
      </div>
 
      {/* Buttons */}
      {!hideButton && (
        <div className={classes.match_btns}>
          <button
            className={classes.monitor_btn}
            onClick={() =>
              handleNavigate({
                id: match?.fixture_id,
                homeTeamId: match?.homeTeamId,
                awayTeamId: match?.awayTeamId,
              })
            }
          >
            {lang === "english"
              ? "View Match"
              : lang === "spanish"
              ? "Ver partido"
              : lang === "french"
              ? "Voir la correspondance"
              : lang === "arabic"
              ? "عرض المباراة"
              : "View Match"}
          </button>
 
          {/* {match?.matchStatus !== "Match Finished" && match?.matchTime == null && (
            <button
              className={classes.monitor_btn}
              onClick={() =>
                teamExists
                  ? handleNavigateToEditTeam({
                      id: match?.fixture_id,
                      homeTeamId: match?.homeTeamId,
                      awayTeamId: match?.awayTeamId,
                    })
                  :
                  handleNavigateToContests({
                      id: match?.fixture_id,
                      homeTeamId: match?.homeTeamId,
                      awayTeamId: match?.awayTeamId,
                    })
              }
            >
              {teamExists
                ? lang === "english"
                  ? "Edit Fantasy Team"
                  : lang === "spanish"
                  ? "Editar equipo de fantasía"
                  : lang === "french"
                  ? "Modifier l'équipe fantastique"
                  : lang === "arabic"
                  ? "تعديل فريق الخيال"
                  : "Edit Fantasy Team"
                : lang === "english"
                ? "Create Fantasy Team"
                : lang === "spanish"
                ? "Crear equipo de fantasía"
                : lang === "french"
                ? "Créer une équipe fantastique"
                : lang === "arabic"
                ? "إنشاء فريق الخيال"
                : "Create Fantasy Team"}
            </button>
          )} */}
        </div>
      )}
    </div>
  );
};
 
export default MatchLayout;